module.exports = __webpack_public_path__ + "groupon/img/share.7fd62b18.png";